import { useTranslation } from "react-i18next";

import saveTimeIcon from "../../images/icons/hourglass.svg";
import costIcon from "../../images/icons/cost.svg";
import securityIcon from "../../images/icons/security.svg";

const ElectronicInvoices = () => {
  const { t } = useTranslation();

  const features = [
    {
      icon: saveTimeIcon,
      title: t("boostGrowth.feature1"),
      description: t("boostGrowth.desc1"),
    },
    {
      icon: costIcon,
      title: t("boostGrowth.feature2"),
      description: t("boostGrowth.desc2"),
    },
    {
      icon: securityIcon,
      title: t("boostGrowth.feature3"),
      description: t("boostGrowth.desc3"),
    },
  ];

  return (
    <section id="our-works" className="bg-main text-white">
      <div className="container relative mx-auto py-24 flex flex-col justify-center items-center gap-14 px-4">
        <div className="absolute z-0 w-96 h-96 bg-primary/10 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 rounded-full blur-[120px]"></div>

        <p className="text-center text-4xl lg:text-5xl font-bold">
          {t("boostGrowth.title")}{" "}
          <span className="text-lightPrimary">{t("boostGrowth.subtitle")}</span>
        </p>

        <div className="w-full grid grid-cols-1 md:grid-cols-3 gap-5 px-8 md:px-0 z-10">
          {features.map((feat) => (
            <div
              key={feat.title}
              className="flex flex-col justify-center items-center bg-grayTransparent rounded-20 px-6 pt-10 pb-14
             transition-all duration-700 ease-out 
             hover:-translate-y-2 hover:scale-105 
             hover:shadow-[0_20px_50px_rgba(33,216,104,0.3)] hover:border hover:border-[#21D868]"
            >
              <img
                src={feat.icon}
                className="mb-10 transition-transform duration-700 ease-out hover:rotate-12"
                alt={feat.title}
              />

              <p className="text-xl font-bold mb-5">{feat.title}</p>

              <p className="text-center text-lightGray px-4 md:px-0">
                {feat.description}
              </p>
            </div>
          ))}
        </div>

        <a
          href="#contactus"
          className="bg-white text-black font-semibold rounded-20 px-8 py-2 
             transition-all duration-500 ease-out
             hover:-translate-y-1 hover:scale-105 hover:shadow-[0_0_20px_rgba(33,216,104,0.4)] hover:text-[#21D868]"
        >
          {t("navbar.contactus")}
        </a>
      </div>
    </section>
  );
};

export default ElectronicInvoices;
